import Axios from 'axios'
import React, { createContext, useCallback, useEffect, useState } from 'react'
// import useGet from './useGet'
// import usePost from './usePost'
import { API_ENDPOINT } from './config'

const URL_PASS_RECOVER = `${API_ENDPOINT}/password/confirm/`
export const AuthContext = createContext()

const axios = Axios.create({ baseURL: API_ENDPOINT })

const AuthContextProvider = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [auth, setAuth] = useState({
    isAuthenticated: false,
    token: localStorage.getItem('token'),
    user: null,
  })
  const [errors, setErrors] = useState({})
  const [forgottenPass, setForgottenPass] = useState({
    isForgotten: false,
    success: false,
    email: '',
  })
  const [passChange, setPassChange] = useState({
    isChangingPassword: false,
    token: '',
    isTokenValid: false,
    password: '',
    password_confirm: '',
    success: false,
    redirect: false,
  })

  const resetPassChange = () => {
    setPassChange({
      isChangingPassword: false,
      token: '',
      isTokenValid: false,
      password: '',
      password_confirm: '',
      success: false,
    })
  }

  const resetForgottenPass = () => {
    setForgottenPass({
      isForgotten: false,
      success: false,
      email: '',
    })
  }

  const processLogout = useCallback(() => {
    setAuth({ isAuthenticated: false, token: null, user: null })
    localStorage.removeItem('token')
  }, [setAuth])
  const processAuthenticate = useCallback((token, user) => {
    setAuth({ isAuthenticated: true, token: token, user: user })
    localStorage.setItem('token', token)
  }, [])
  const startFetch = () => {
    setErrors({})
    setIsLoading(true)
  }

  const login = ({ username, password }) => {
    startFetch()
    axios
      .post(`/login`, { username, password })
      .then((res) => {
        processAuthenticate(res.data.token.key, res.data.user)
      })
      .catch((error) => {
        processLogout()
        setErrors({ ...error.response.data })
      })
      .finally(() => setIsLoading(false))
  }

  const logged = useCallback(async () => {
    startFetch()
    axios
      .post(`/logged`, {
        token: localStorage.getItem('token'),
      })
      .then((res) => {
        processAuthenticate(res.data.token.key, res.data.user)
      })
      .catch((error) => {
        processLogout()
      })
      .finally(() => setIsLoading(false))
  }, [processLogout, processAuthenticate])

  const logout = async () => {
    startFetch()
    axios
      .post(`/logout`, {
        token: auth.token,
      })
      .then((res) => {
        processLogout()
      })
      .catch((error) => {
        setErrors({ ...error.response.data })
      })
      .finally(() => setIsLoading(false))
  }

  const sendPassChange = () => {
    startFetch()
    setForgottenPass({ ...forgottenPass, success: false })
    axios
      .post(`/password/reset/`, {
        ...forgottenPass,
      })
      .then((res) => {
        setForgottenPass({ ...forgottenPass, success: true })
      })
      .catch((error) => {
        setErrors({ ...error.response.data })
      })
      .finally(() => setIsLoading(false))
  }
  const url = window.location
  if (
    url.pathname.includes(URL_PASS_RECOVER) &&
    !passChange.isChangingPassword
  ) {
    setPassChange({
      ...passChange,
      isChangingPassword: true,
      token: url.pathname.slice(URL_PASS_RECOVER.length).replace('/', ''),
      isTokenValid: true,
    })
  }

  useEffect(() => {
    let timer = setInterval(() => {
      if (auth.token && !auth.isAuthenticated) logged()
    }, 60000)
    if (auth.token && !auth.isAuthenticated) logged()
    if (auth.isAuthenticated && auth.user.is_new_user)
      setPassChange((passChange) => ({
        ...passChange,
        isChangingPassword: true,
      }))

    return () => {
      clearInterval(timer)
    }
  }, [auth, logged])

  return (
    <AuthContext.Provider
      value={{
        isLoading,
        auth,
        isAuthenticated: auth.isAuthenticated,
        login,
        logout,
        logged,
        errors,
        setErrors,
        forgottenPass,
        setForgottenPass,
        resetForgottenPass,
        sendPassChange,
        passChange,
        setPassChange,
        resetPassChange,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthContextProvider
